var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.8397,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4416 3.09608C11.4416 3.26146 11.4416 3.42683 11.4416 3.59221C11.4416 5.40601 11.4471 7.21981 11.4361 9.0336C11.4361 9.25766 11.5022 9.31101 11.7278 9.31101C13.1476 9.30034 14.5675 9.30567 15.9873 9.30567C16.1854 9.30567 16.2845 9.31101 16.1634 9.5404C14.6115 12.5172 13.0706 15.4993 11.5297 18.476C11.5022 18.5294 11.4691 18.5774 11.3921 18.7001C11.3921 18.5294 11.3921 18.4387 11.3921 18.3427C11.3921 16.4595 11.3866 14.571 11.3976 12.6879C11.3976 12.4051 11.315 12.3571 11.0454 12.3625C9.64205 12.3731 8.24423 12.3625 6.8409 12.3731C6.61526 12.3731 6.57124 12.3358 6.6813 12.1277C8.22772 9.1563 9.76312 6.18487 11.304 3.21345C11.326 3.16543 11.3591 3.12276 11.3866 3.08008C11.4031 3.08541 11.4196 3.09075 11.4416 3.09608Z",
    fill: "#1E1F25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrike);
export default __webpack_public_path__ + "static/media/strike.44bcc1770d7c89efd1b2d303f35978ef.svg";
export { ForwardRef as ReactComponent };